import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {BrokerUserModel} from '../../../../../services/broker/model/brokerUserModel';
import {BrokerUserRequest} from '../../../../../services/broker/model/brokerUserRequest';
import {KeyWordDto} from '../../../../../services/chat/model/keyWordDto';
import {BrokerUserInviteRequest} from '../../../../../services/broker/model/brokerUserInviteRequest';
import {BrokerUserOwnProfileModel} from '../../../../../services/broker/model/brokerUserOwnProfileModel';

@Injectable({
    providedIn: 'root'
})

export class UsersHTTPService {
    private brokerUrl = `${environment.apiUrl}/broker`;

    constructor(
        private httpClient: HttpClient
    ) {
    }

    searchUsers(query?: KeyWordDto): Observable<BrokerUserModel[]> {
        const url = `${this.brokerUrl}/user/list`;
        return this.httpClient.post<BrokerUserModel[]>(url, {
            keyWord: query?.keyWord || ""
        });
    }

    inviteUser(query: BrokerUserInviteRequest): Observable<BrokerUserModel> {
        const url = `${this.brokerUrl}/user/invite`;
        return this.httpClient.post<BrokerUserModel>(url, query);
    }

    deleteInvite(id: string): Observable<void> {
        const url = `${this.brokerUrl}/user/invite/${id}`;
        return this.httpClient.delete<void>(url);
    }

    getUserProfile(): Observable<BrokerUserOwnProfileModel> {
        const url = `${this.brokerUrl}/user/own`;
        return this.httpClient.get<BrokerUserOwnProfileModel>(url);
    }

    editUserProfile(query: BrokerUserOwnProfileModel): Observable<BrokerUserOwnProfileModel> {
        const url = `${this.brokerUrl}/user/own`;
        return this.httpClient.put<BrokerUserOwnProfileModel>(url, query);
    }

    editUser(id: string, query: BrokerUserRequest): Observable<BrokerUserModel> {
        const url = `${this.brokerUrl}/user/${id}`;
        return this.httpClient.put<BrokerUserModel>(url, query);
    }

    deleteUser(id: string): Observable<void> {
        const url = `${this.brokerUrl}/user/${id}`;
        return this.httpClient.delete<void>(url);
    }
}
